var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.001,
    height: 16,
    viewBox: "0 0 16.001 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15759",
    "data-name": "Path 15759",
    d: "M13.75-13.8.75-6.3A1.5,1.5,0,0,0,.928-3.616L4.5-2.138V.5a1.5,1.5,0,0,0,2.706.894L8.575-.453l3.5,1.444a1.516,1.516,0,0,0,.572.112,1.5,1.5,0,0,0,.738-.194,1.51,1.51,0,0,0,.747-1.078l1.856-12.1A1.5,1.5,0,0,0,13.75-13.8ZM6,.5V-1.519l1.144.472Zm6.644-.9L7.837-2.381,12.219-8.7a.5.5,0,0,0-.741-.663L4.869-3.606,1.5-5l13-7.5Z",
    transform: "translate(-0.001 13.999)",
    fill: "#cbcbd1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/paper-plane.ca4fdf5a0ed33daf273b5a4b6181100d.svg";
export { ForwardRef as ReactComponent };